/* eslint-disable react/jsx-props-no-spreading */
import Picker from '../Picker/Picker';
import { IPickerProps, PickerType } from '../Picker/types';
import { IProductV4, PRODUCT_TYPE } from 'src/types/product';

const fetchProductV4Url: string = 'v4/products';

const params = {
  types: [PRODUCT_TYPE.PRODUCT],
  only_for_combo: 1,
};

const LazyProductsPicker = ({ fetchUrl, fetchParams, ...props }: IPickerProps<IProductV4>): JSX.Element => {
  return (
    <Picker<IProductV4> {...props} type={PickerType.LAZY} fetchUrl={fetchUrl || fetchProductV4Url} fetchParams={{ ...params, ...fetchParams }} />
  );
};

export default LazyProductsPicker;
